import { Button } from '@material-ui/core';
import React from 'react';
import { ResponsiveDialogActions } from '../dialog';

interface IProps {
  onClick: () => void;
}

const DeleteBtn: React.FC<IProps> = ({ onClick }) => {
  return (
    <ResponsiveDialogActions>
      <Button
        className='orangeLink'
        data-cy='cancel'
        // disabled={isSubmitting}
        onClick={onClick}
      >
        Delete
      </Button>
    </ResponsiveDialogActions>
  );
};

export default DeleteBtn;
